/**
 * File: Hero.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v3.1.0
 * Created: 2025-11-11
 * Last Updated: 2026-02-11
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { TextButton } from "../ui/Buttons";
import Carousel from "./Carousel";
import ThreeModel from "../../utils/ThreeModel";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ImageHero({
    image,
    headline,
    subheadline,
    primaryButton,
    primaryOnClick,
    secondaryButton,
    secondaryOnClick,
}) {
    return (
        <>
            <div className="image-hero">
                <div className="image-hero__image-container">
                    <img className={"image-hero__image"} src={image}></img>
                </div>
                <div className="image-hero__content">
                    <div className="image-hero__headers">
                        <h1>{headline}</h1>
                        <p className="image-hero__subheadline">{subheadline}</p>
                    </div>
                    {true && (
                        <div className="image-hero__buttons">
                            <TextButton
                                {...primaryButton}
                                onClick={primaryOnClick}
                            />
                            <TextButton
                                {...secondaryButton}
                                onClick={secondaryOnClick}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ModelHero({
    headline,
    subheadline,
    primaryButton,
    primaryOnClick,
    secondaryButton,
    secondaryOnClick,
}) {
    return (
        <>
            <div className="model-hero">
                <div className="model-hero__model-container">
                    <ThreeModel />
                </div>
                <div className="model-hero__content">
                    <div className="model-hero__headers">
                        <h1>{headline}</h1>
                        <p className="model-hero__subheadline">{subheadline}</p>
                    </div>
                    {true && (
                        <div className="model-hero__buttons">
                            <TextButton
                                {...primaryButton}
                                onClick={primaryOnClick}
                            />
                            <TextButton
                                {...secondaryButton}
                                onClick={secondaryOnClick}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export { ImageHero, ModelHero };
